import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SmallTag',
  props: {
    color: {},
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex justify-between overflow-scroll h-4 rounded-xs text-center", { 'w-full': !_ctx.small }])
  }, [
    (_ctx.color != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["h-4 text-xs grid place-content-center w-full px-xs", {
        [`bg-red`]: props.color == 'red',
        [`bg-blue-3`]: props.color == 'blue',
        [`bg-blue-4`]: props.color == 'lightblue',
        [`bg-orange`]: props.color == 'orange',
        [`bg-orange-2`]: props.color == 'darkorange',
        [`bg-green`]: props.color == 'green',
        [`bg-yellow-300`]: props.color == 'yellow',
        [`bg-gray-500`]: props.color == 'gray',
        [`bg-pink`]: props.color == 'pink',
        [`bg-purple`]: props.color == 'purple',
        'w-auto': _ctx.small,
        'rounded-xs': _ctx.small,
      }])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})